import { Component, Input, Output, EventEmitter, HostListener, OnInit } from '@angular/core';
import { Signatories } from 'src/app/contract/shared/contract.model';

@Component({
  selector: 'app-custom-component',
  templateUrl: './custom.component.html',
  styleUrl: './custom.component.css'
})
export class CustomComponent implements OnInit {
  @Input() dropPositionX: string;
  @Input() dropPositionY: string;
  @Input() droppedPage: string;
  @Input() data: Signatories;
  @Input() isSelected: boolean = false;
  @Input() signatories: any[] = [];
  @Output() onSelect = new EventEmitter<void>();
  @Output() onPropertiesChange = new EventEmitter<{ signatory: string, pageNumbers: string, pageOption: string }>();
  @Output() onRemove = new EventEmitter<void>();

  pageOptions = [
    'CURRENT',
    'EVEN',
    'ODD',
    'ALL',
    'SPECIFY',
    'FIRST',
    'LAST'
  ];

  selectedSignatory: string;
  selectedPageOption: string = 'CURRENT';
  pageNumbers: string = '';
  showProperties: boolean = false;

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.isSelected) {
      this.showProperties = false;
    }
  }

  ngOnInit(): void {
    this.selectedSignatory = this.data.EmailId;
  }

  selectComponent() {
    this.onSelect.emit();
  }

  onPageChange() {
    if (this.selectedPageOption !== 'SPECIFY') {
      this.pageNumbers = "";
    }
  }

  toggleSettings(event: Event) {
    event.stopPropagation();
    this.showProperties = !this.showProperties;
  }

  onSubmit() {
    this.onPropertiesChange.emit({
      signatory: this.selectedSignatory,
      pageNumbers: this.pageNumbers,
      pageOption: this.selectedPageOption
    });
    this.showProperties = false;
  }

  removeComponent(event: Event) {
    event.stopPropagation();
    this.onRemove.emit();
  }

}
